import { Flex } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { BodyM, HeaderS } from "ui/Typography/Typography";

export function EmptyState() {
  const intl = useIntl();
  return (
    <Flex direction="column" justify="center" align="center" h="100%" gap="s100">
      <HeaderS textAlign="center">
        {intl.formatMessage({
          id: "pages.inventory.shelf-changes.empty-state.title",
        })}
      </HeaderS>
      <BodyM textAlign="center" color="gray.800">
        {intl.formatMessage({
          id: "pages.inventory.shelf-changes.empty-state.body",
        })}
      </BodyM>
    </Flex>
  );
}
